<template>
	<!-- <div> -->
	<div class="colorBox boxR-light bdSub hasDropList hasDropList-hover">
		<div class="colorDisplay h100pct" :style="{ 'background-color': active }"></div>
		<div class="actionBtn w1x h100pct bgContent posA taC"><Icon name="caret-d" class="w05x h05x fSub posA" /></div>
		<ul v-if="ready" class="dropList bgContent taC cContent curA pd1x cb fL_E" :style="{ width: (1.75 + 1.75 * colorClass.length) / 2 + 'rem' }">
			<template v-if="dropShow">
				<li v-for="(cClass, index) in colorClass" :key="index">
					<div v-for="(color, i) in cClass" :key="color">
						<div v-if="i == 0" class="mainStyle mb05x pb05x bdSub-bottom">
							<button
								class="w105x h105x dpB"
								:class="{ colorActive: active == color }"
								:style="{ 'background-color': color }"
								@click="select(color)"
								type="button"
							></button>
						</div>
						<button
							v-else-if="i > 0"
							class="w105x h105x mt025x dpB"
							:class="{ colorActive: active == color }"
							:style="{ 'background-color': color }"
							@click="select(color)"
							type="button"
						></button>
					</div>
				</li>
			</template>
		</ul>
	</div>
	<!-- <Window v-if="openSelect" :title="getLanguageStr('颜色选取','颜色选取')" :bg="true" ref="Window"></Window> -->
	<!-- </div> -->
</template>
<script>
import * as lib from "@/util/lib";

export default {
	name: "",
	components: {},
	props: {
		value: {
			type: String,
			default: "",
		},
		group: {
			//颜色小组通道
			type: String,
			default: "",
		},
	},
	data() {
		return {
			hover: false,
			dropShow: true,
			ready: false,
			active: this.value,
			colorClass: [
				["#4883F9", "#9CC3FF", "#73A6FF", "#3363D4", "#2146AD", "#132E87"],
				["#33C3BC", "#7FDBD1", "#57CFC5", "#219C9A", "#137475", "#094C4F"],
				["#3AC9EE", "#8FF0FF", "#64E1FA", "#26A1C7", "#167CA1", "#0B597A"],
				["#4CC73A", "#9AE089", "#73D45F", "#33A127", "#1E7A17", "#0E540C"],
				["#FCCA42", "#FFEA94", "#FFDC6B", "#D6A32D", "#B07F1C", "#8A5D0F"],
				["#7749F2", "#BE9EFF", "#9F75FF", "#5733CC", "#3C21A6", "#251380"],
				["#FF804A", "#FFC09C", "#FFA273", "#D96034", "#B34422", "#8C2C14"],
				["#F8544A", "#FFA99E", "#FF8175", "#D13734", "#AB2224", "#85141A"],
				["#ED458D", "#FF9CC0", "#FA70A7", "#C73076", "#A11F60", "#7A1149"],
				["#91C267", "#D7F5B5", "#B8E986", "#6E9C4B", "#4D7532", "#324F21"],
				["#B928C3", "#DB74DB", "#CA4CCF", "#8E199C", "#670D75", "#43054F"],
			],
			dynamic: null,
		};
	},
	watch: {
		value: function () {
			this.active = this.value;
		},
	},
	created() {},
	methods: {
		getLanguageStr,
		dropPositionStyle: function () {
			//计算下拉呈现的位置
			let scope = [stage.space, $(window).width()];
			let $this = $(this.$el);
			let $drop = $(this.$el).find(".dropList");
			let ml = -$drop.innerWidth() / 2,
				bottom = "",
				top = "unset";
			if ($this.parents(".mCSB_container").length) {
				scope = [$this.parents(".mCSB_container").first().offset().left, $this.parents(".mCSB_container").first().innerWidth()];
			}

			if ($this.offset().left + $this.innerWidth() / 2 + $drop.innerWidth() < scope[0]) {
				//超过左边
				ml = -$this.innerWidth() / 2;
			} else if ($this.offset().left + $this.innerWidth() / 2 + $drop.innerWidth() > scope[1]) {
				//超过右侧
				ml = -$drop.innerWidth() + $this.innerWidth() / 2;
			}

			if ($this.offset().top + $this.innerHeight() + $drop.innerHeight() > $(window).height()) {
				//超过底边
				bottom = $this.innerHeight() + 2;
			}
			if ($this.offset().top - $this.innerHeight() - $drop.innerHeight() < stage.space) {
				//超过上边
				bottom = "";
			}
			// else{//默认居中展示
			// 	ml=-$(this.$el).find(".dropList").width()/2+"px";
			// }
			$(this.$el).find(".dropList").css({
				"margin-left": ml,
				top,
				bottom,
			});
		},
		select: function (color) {
			this.active = color;
			$(this.$el).addClass("peN");
			setTimeout(() => {
				$(this.$el).removeClass("peN");
			}, 500);
			this.$emit("input", color);
			this.$emit("Click", color);
		},
		getAutoColor: function () {
			let classIndex = Math.round(Math.random() * (this.colorClass.length - 1));
			let colorIndex = Math.round(this.colorClass[classIndex].length - 1);
			if (this.group && !stage.colorSelectGroup[this.group]) {
				//创建颜色小组
				stage.colorSelectGroup[this.group] = {
					x: 0,
					y: 0,
					clear: function () {
						this.x = this.y = 0;
					},
				};
			}
			if (stage.colorSelectGroup[this.group]) {
				//已有颜色小组
				let thisChannel = stage.colorSelectGroup[this.group];
				classIndex = thisChannel.x;
				colorIndex = thisChannel.y;
				if (thisChannel.x + 1 >= this.colorClass.length) {
					//x轴溢出
					thisChannel.x = 0;
					if (thisChannel.y + 1 >= this.colorClass[thisChannel.x].length) {
						thisChannel.y = 0;
					} else {
						++thisChannel.y;
					}
				} else {
					++thisChannel.x;
				}
			}
			this.select(this.colorClass[classIndex][colorIndex]);
		},
	},
	computed: {},
	mounted() {
		if (!this.active) {
			this.getAutoColor();
		}
		setTimeout(() => {
			this.ready = true;
			this.$nextTick(() => {
				$(this.$el).on("mouseenter", (e) => {
					this.hover = this.dropShow = true;
					this.$nextTick(() => {
						this.dropPositionStyle();
					});
				});
				$(this.$el).on("mouseleave", (e) => {
					setTimeout(() => {
						if (this.hover == false) {
							this.dropShow = false;
						}
					}, 200);
				});
				this.dropPositionStyle();
				setTimeout(() => {
					this.dropShow = false;
				}, 0);
			});
		}, Math.random() * 20);
	},
	destroyed() {},
};
</script>
<style lang="scss" scoped>
.mt025x {
	margin: {
		top: 0.25rem;
	}
}
.colorBox {
	width: 3.5rem;
	height: 2rem;
	padding: 0.125rem;
	.colorDisplay {
		border-radius: $radius / 4;
	}
	.actionBtn {
		top: 0;
		right: 0;
		> * {
			margin: {
				top: -0.25rem;
				left: -0.25rem;
			}
			top: 50%;
			left: 50%;
		}
	}
	button::after {
		display: block;
		width: 100%;
		height: 100%;
		content: "";
		border: 1px solid transparent;
		box-shadow: 0 0 0 1px transparent inset;
		@extend %tra-fast;
	}
	button:hover,
	.colorActive {
		&::after {
			border-color: $primary;
			box-shadow: 0 0 0 1px #fff inset;
		}
	}
}
.dropList {
	left: 50%;
	> * + * > * button {
		margin: {
			left: 0.25rem;
		}
	}
	> * + * > *:first-child {
		.mainStyle {
			padding: {
				left: 0.25rem;
			}
		}
		button {
			margin-left: unset;
		}
	}
	//button{width:2rem;height:2rem;border-radius:$radius;}
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/SelectColor.vue